"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.analyticsPusherLibrary = undefined;

var _getIterator2 = require("babel-runtime/core-js/get-iterator");

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _regenerator = require("babel-runtime/regenerator");

var _regenerator2 = _interopRequireDefault(_regenerator);

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _asyncToGenerator2 = require("babel-runtime/helpers/asyncToGenerator");

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _storageProvider = require("./storageProvider");

var _storageProvider2 = _interopRequireDefault(_storageProvider);

var _common = require("./common");

var _common2 = _interopRequireDefault(_common);

var _localize = require("linksoft/core/localize");

var _localize2 = _interopRequireDefault(_localize);

var _utils = require("./cart/components/utils");

var _utils2 = _interopRequireDefault(_utils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Resx = (0, _localize2.default)('Common', 'App');

var analyticsPusherLibrary = exports.analyticsPusherLibrary = {
    customerDetails: null,
    getCustomerDetails: function () {
        var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
            var customerInfoElement;
            return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _context.prev = 0;

                            if (!analyticsPusherLibrary.customerDetails) {
                                _context.next = 3;
                                break;
                            }

                            return _context.abrupt("return", analyticsPusherLibrary.customerDetails);

                        case 3:
                            customerInfoElement = document.getElementById('customerInfoElement');

                            if (customerInfoElement) {
                                _context.next = 6;
                                break;
                            }

                            return _context.abrupt("return", null);

                        case 6:

                            analyticsPusherLibrary.customerDetails = (0, _extends3.default)({
                                customerReference: customerInfoElement.value
                            }, customerInfoElement.dataset);
                            return _context.abrupt("return", analyticsPusherLibrary.customerDetails);

                        case 10:
                            _context.prev = 10;
                            _context.t0 = _context["catch"](0);

                            console.error("Error in getCustomerDetails method.", _context.t0);
                            return _context.abrupt("return", null);

                        case 14:
                        case "end":
                            return _context.stop();
                    }
                }
            }, _callee, undefined, [[0, 10]]);
        }));

        return function getCustomerDetails() {
            return _ref.apply(this, arguments);
        };
    }(),
    preventMultiplePushes: function () {
        var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2() {
            var timeMs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1000;
            var multipleGaPushKeeperKey, nowSec, multipleGaPushKeeper;
            return _regenerator2.default.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            // prevent performing multiple pushes in one second
                            multipleGaPushKeeperKey = 'multipleGaPushKeeper';
                            nowSec = Math.floor(new Date().getTime() / timeMs);
                            multipleGaPushKeeper = parseInt(_storageProvider2.default.getValueSession(multipleGaPushKeeperKey, 1) || '0');
                            // console.debug(`sessionValue: ${multipleGaPushKeeper}, now: ${nowSec}`);

                            if (!(multipleGaPushKeeper === nowSec)) {
                                _context2.next = 5;
                                break;
                            }

                            return _context2.abrupt("return", true);

                        case 5:
                            _storageProvider2.default.setValueSession(multipleGaPushKeeperKey, nowSec);
                            return _context2.abrupt("return", false);

                        case 7:
                        case "end":
                            return _context2.stop();
                    }
                }
            }, _callee2, undefined);
        }));

        return function preventMultiplePushes() {
            return _ref2.apply(this, arguments);
        };
    }(),

    pushLogin: function () {
        var _ref3 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3() {
            var settings, loginPushedKey, alreadyPushed, dataObject;
            return _regenerator2.default.wrap(function _callee3$(_context3) {
                while (1) {
                    switch (_context3.prev = _context3.next) {
                        case 0:
                            _context3.prev = 0;
                            _context3.next = 3;
                            return analyticsPusherLibrary.getCustomerDetails();

                        case 3:
                            settings = _context3.sent;

                            if (!settings.isAnonymous) {
                                _context3.next = 6;
                                break;
                            }

                            return _context3.abrupt("return");

                        case 6:
                            loginPushedKey = 'loginPushedIntoGoogleAnalytics';
                            _context3.next = 9;
                            return _storageProvider2.default.getValueSession(loginPushedKey, 300);

                        case 9:
                            alreadyPushed = _context3.sent;

                            if (!alreadyPushed) {
                                _context3.next = 12;
                                break;
                            }

                            return _context3.abrupt("return");

                        case 12:
                            dataObject = {
                                event: 'login',
                                email: settings.customerEmail,
                                user_id: settings.customerReference
                            };
                            _context3.next = 15;
                            return analyticsPusherLibrary.performPush(dataObject);

                        case 15:
                            _context3.next = 17;
                            return _storageProvider2.default.setValueSession(loginPushedKey, true);

                        case 17:
                            _context3.next = 22;
                            break;

                        case 19:
                            _context3.prev = 19;
                            _context3.t0 = _context3["catch"](0);

                            console.error("Error in performing Datalayer push - Login.", _context3.t0);

                        case 22:
                        case "end":
                            return _context3.stop();
                    }
                }
            }, _callee3, undefined, [[0, 19]]);
        }));

        return function pushLogin() {
            return _ref3.apply(this, arguments);
        };
    }(),

    pushProductDetail: function () {
        var _ref4 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee4() {
            var element, model, dataObject;
            return _regenerator2.default.wrap(function _callee4$(_context4) {
                while (1) {
                    switch (_context4.prev = _context4.next) {
                        case 0:
                            _context4.prev = 0;
                            element = document.getElementById('productDetailSerializedDataElement');
                            // if element is not present, it means, we are not on the right page

                            if (!(!element || !element.value)) {
                                _context4.next = 4;
                                break;
                            }

                            return _context4.abrupt("return");

                        case 4:
                            model = JSON.parse(element.value);
                            dataObject = {
                                event: 'view_item',
                                ecommerce: {
                                    items: [model]
                                }
                            };
                            _context4.next = 8;
                            return analyticsPusherLibrary.performPush(dataObject, true);

                        case 8:
                            _context4.next = 14;
                            break;

                        case 10:
                            _context4.prev = 10;
                            _context4.t0 = _context4["catch"](0);
                            _context4.next = 14;
                            return console.error("Error in performing push of viewed list (pushProductDetail).", _context4.t0);

                        case 14:
                        case "end":
                            return _context4.stop();
                    }
                }
            }, _callee4, undefined, [[0, 10]]);
        }));

        return function pushProductDetail() {
            return _ref4.apply(this, arguments);
        };
    }(),

    pushViewList: function () {
        var _ref5 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee5() {
            var element, category, model, dataObject;
            return _regenerator2.default.wrap(function _callee5$(_context5) {
                while (1) {
                    switch (_context5.prev = _context5.next) {
                        case 0:
                            _context5.prev = 0;
                            element = document.getElementById('productListSerializedDataElement');
                            // if element is not present, it means, we are not on the right page

                            if (!(!element || !element.value)) {
                                _context5.next = 4;
                                break;
                            }

                            return _context5.abrupt("return");

                        case 4:
                            category = document.location.pathname.replaceAll('/', '');
                            model = JSON.parse(element.value);
                            dataObject = {
                                event: 'view_item_list',
                                ecommerce: {
                                    type: "view_category",
                                    item_list_name: category,
                                    category_level_0: category,
                                    category_depth: 1,
                                    items: model
                                }
                            };
                            _context5.next = 9;
                            return analyticsPusherLibrary.performPush(dataObject, true);

                        case 9:
                            _context5.next = 15;
                            break;

                        case 11:
                            _context5.prev = 11;
                            _context5.t0 = _context5["catch"](0);
                            _context5.next = 15;
                            return console.error("Error in performing push of viewed list.", _context5.t0);

                        case 15:
                        case "end":
                            return _context5.stop();
                    }
                }
            }, _callee5, undefined, [[0, 11]]);
        }));

        return function pushViewList() {
            return _ref5.apply(this, arguments);
        };
    }(),

    cratePushItem: function cratePushItem(item, amount) {
        var brandName = item.brandName || (item.brand || {}).name;
        var categoryName = item.categoryName || (item.category || {}).name;
        var priceObject = item.resultPrice;
        // enforce adding 1 item, typically from carousels, lists, details by clicking on green button 
        // if amount is specified, it is probably from cart page
        var singleProductAdd = typeof amount !== 'number';

        if (!priceObject && item.price) {
            if (item.price.unitPrice && singleProductAdd) priceObject = item.price.unitPrice;else if (item.price.totalPrice && !singleProductAdd) priceObject = item.price.totalPrice;else if (typeof item.price === 'number') priceObject = { finalPriceWithoutVat: item.price, nominalDiscount: 0 };else priceObject = {};
        }

        return {
            item_id: item.ean,
            name: item.productName || item.name,
            currency: _utils2.default.getCurrencyIntCode(),
            discount: priceObject.nominalDiscount,
            price: _common2.default.roundToDecimalPlaces(priceObject.finalPriceWithoutVat || priceObject.finalPrice, 2),
            item_brand: brandName,
            item_category_0: categoryName,
            quantity: singleProductAdd ? 1 : Math.abs(amount)
        };
    },

    addItemToCart: function () {
        var _ref6 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee6(item, state, amountDiff) {
            var cart, ciIndex, resultPrice, totalValue, totalValueWithVat, addedItems, totalCart, action, event, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, iteratedItem, rp, dataObject;

            return _regenerator2.default.wrap(function _callee6$(_context6) {
                while (1) {
                    switch (_context6.prev = _context6.next) {
                        case 0:
                            _context6.prev = 0;

                            if (!(!item || !state)) {
                                _context6.next = 4;
                                break;
                            }

                            console.warn("Object item or state assigned into analyticsPusherLibrary/pushAddToCart is null or empty. item: " + item + ", state: " + state);
                            return _context6.abrupt("return");

                        case 4:
                            cart = (0, _extends3.default)({}, state.cart);
                            // replace item of same product by current item to ensure, we have latest values

                            ciIndex = cart.items.findIndex(function (ci) {
                                return ci.id === item.id;
                            });

                            if (ciIndex) cart.items[ciIndex] = item;

                            resultPrice = item.resultPrice;

                            if (!resultPrice) {
                                resultPrice = (item.price || {}).totalPrice || {};
                            }

                            totalValue = 0, totalValueWithVat = 0;
                            addedItems = [analyticsPusherLibrary.cratePushItem(item, amountDiff)];
                            totalCart = cart.items.map(function (i) {
                                return analyticsPusherLibrary.cratePushItem(i, i.amount);
                            });
                            action = amountDiff < 0 ? 'remove' : 'add';
                            event = amountDiff < 0 ? 'remove_to_cart' : 'add_to_cart';
                            _iteratorNormalCompletion = true;
                            _didIteratorError = false;
                            _iteratorError = undefined;
                            _context6.prev = 17;


                            for (_iterator = (0, _getIterator3.default)(cart.items); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                                iteratedItem = _step.value;
                                rp = iteratedItem.resultPrice || (iteratedItem.price || {}).totalPrice || {};

                                totalValue += rp.finalPriceWithoutVat || 0;
                                totalValueWithVat += rp.finalPrice || 0;
                            }

                            _context6.next = 25;
                            break;

                        case 21:
                            _context6.prev = 21;
                            _context6.t0 = _context6["catch"](17);
                            _didIteratorError = true;
                            _iteratorError = _context6.t0;

                        case 25:
                            _context6.prev = 25;
                            _context6.prev = 26;

                            if (!_iteratorNormalCompletion && _iterator.return) {
                                _iterator.return();
                            }

                        case 28:
                            _context6.prev = 28;

                            if (!_didIteratorError) {
                                _context6.next = 31;
                                break;
                            }

                            throw _iteratorError;

                        case 31:
                            return _context6.finish(28);

                        case 32:
                            return _context6.finish(25);

                        case 33:
                            dataObject = {
                                currency: _utils2.default.getCurrencyIntCode(),
                                event: event,
                                action: action,
                                value: _common2.default.roundToDecimalPlaces(resultPrice.finalPriceWithoutVat || 0, 2),
                                total_value: _common2.default.roundToDecimalPlaces(totalValue, 2),
                                value_with_vat: _common2.default.roundToDecimalPlaces(totalValueWithVat, 2),
                                ecommerce: {
                                    items: addedItems,
                                    total_cart: totalCart
                                }
                            };
                            _context6.next = 36;
                            return analyticsPusherLibrary.performPush(dataObject, true);

                        case 36:
                            _context6.next = 42;
                            break;

                        case 38:
                            _context6.prev = 38;
                            _context6.t1 = _context6["catch"](0);
                            _context6.next = 42;
                            return console.error("Error in performing push of viewed list.", _context6.t1);

                        case 42:
                        case "end":
                            return _context6.stop();
                    }
                }
            }, _callee6, undefined, [[0, 38], [17, 21, 25, 33], [26,, 28, 32]]);
        }));

        return function addItemToCart(_x2, _x3, _x4) {
            return _ref6.apply(this, arguments);
        };
    }(),

    getCheckoutNameByStep: function () {
        var _ref7 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee7(step) {
            return _regenerator2.default.wrap(function _callee7$(_context7) {
                while (1) {
                    switch (_context7.prev = _context7.next) {
                        case 0:
                            _context7.t0 = step;
                            _context7.next = _context7.t0 === 1 ? 3 : _context7.t0 === 2 ? 4 : _context7.t0 === 3 ? 5 : 6;
                            break;

                        case 3:
                            return _context7.abrupt("return", Resx.App.ShoppingCart);

                        case 4:
                            return _context7.abrupt("return", Resx.App.TransportationAndPaymentTitle);

                        case 5:
                            return _context7.abrupt("return", Resx.App.DeliveryInformationAndSummaryTitle);

                        case 6:
                            return _context7.abrupt("return", '');

                        case 7:
                        case "end":
                            return _context7.stop();
                    }
                }
            }, _callee7, undefined);
        }));

        return function getCheckoutNameByStep(_x5) {
            return _ref7.apply(this, arguments);
        };
    }(),

    fillPaymentOrDelivery: function () {
        var _ref8 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee8(cart, dataObject, isPayment) {
            var selectedId, items, nameProperty, priceProperty, selItemPriceProperty, selectedItem;
            return _regenerator2.default.wrap(function _callee8$(_context8) {
                while (1) {
                    switch (_context8.prev = _context8.next) {
                        case 0:
                            _context8.prev = 0;
                            selectedId = isPayment ? cart.paymentTypeId : cart.deliveryTypeId;
                            items = isPayment ? cart.paymentTypes : _utils2.default.transformDeliveryItemsToArray(cart.deliveryTypes);
                            nameProperty = isPayment ? 'payment_name' : 'shipping_name';
                            priceProperty = isPayment ? 'payment' : 'shipping';
                            selItemPriceProperty = isPayment ? 'paymentPrice' : 'deliveryPrice';


                            if (selectedId && Array.isArray(items)) {
                                selectedItem = items.find(function (pt) {
                                    return pt.id === selectedId;
                                });

                                if (selectedItem) {
                                    dataObject[nameProperty] = selectedItem.name;
                                    dataObject[priceProperty] = selectedItem[selItemPriceProperty];
                                }
                            }
                            _context8.next = 13;
                            break;

                        case 9:
                            _context8.prev = 9;
                            _context8.t0 = _context8["catch"](0);
                            _context8.next = 13;
                            return console.error("Error in filling " + (isPayment ? "payment" : "delivery") + " fillPaymentOrDelivery.", _context8.t0);

                        case 13:
                        case "end":
                            return _context8.stop();
                    }
                }
            }, _callee8, undefined, [[0, 9]]);
        }));

        return function fillPaymentOrDelivery(_x6, _x7, _x8) {
            return _ref8.apply(this, arguments);
        };
    }(),

    getTotalQuantity: function () {
        var _ref9 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee9(items) {
            return _regenerator2.default.wrap(function _callee9$(_context9) {
                while (1) {
                    switch (_context9.prev = _context9.next) {
                        case 0:
                            return _context9.abrupt("return", items.reduce(function (partialSum, a) {
                                return partialSum + a.quantity;
                            }, 0) || 0);

                        case 1:
                        case "end":
                            return _context9.stop();
                    }
                }
            }, _callee9, undefined);
        }));

        return function getTotalQuantity(_x9) {
            return _ref9.apply(this, arguments);
        };
    }(),

    getPriceValuesObject: function () {
        var _ref10 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee10(cart) {
            return _regenerator2.default.wrap(function _callee10$(_context10) {
                while (1) {
                    switch (_context10.prev = _context10.next) {
                        case 0:
                            return _context10.abrupt("return", {
                                currency: _utils2.default.getCurrencyIntCode(),
                                value: cart.totalPrice.finalPriceWithoutVat || 0,
                                value_with_vat: cart.totalPrice.finalPrice || 0,
                                tax: cart.totalVat || 0
                            });

                        case 1:
                        case "end":
                            return _context10.stop();
                    }
                }
            }, _callee10, undefined);
        }));

        return function getPriceValuesObject(_x10) {
            return _ref10.apply(this, arguments);
        };
    }(),

    addCouponValues: function () {
        var _ref11 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee11(dataObject, cart) {
            return _regenerator2.default.wrap(function _callee11$(_context11) {
                while (1) {
                    switch (_context11.prev = _context11.next) {
                        case 0:
                            if (cart.coupon) {
                                dataObject.coupon = cart.coupon.code || '';
                                dataObject.coupon_type = cart.coupon.name || '';
                                dataObject.coupon_absolute_value = cart.coupon.value || 0;
                                dataObject.coupon_percentage_value = cart.totalPrice.percentageDiscount || 0;
                            }

                        case 1:
                        case "end":
                            return _context11.stop();
                    }
                }
            }, _callee11, undefined);
        }));

        return function addCouponValues(_x11, _x12) {
            return _ref11.apply(this, arguments);
        };
    }(),

    pushCheckout: function () {
        var _ref12 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee12(step, cart) {
            var items, total_quantity, dataObject;
            return _regenerator2.default.wrap(function _callee12$(_context12) {
                while (1) {
                    switch (_context12.prev = _context12.next) {
                        case 0:
                            _context12.prev = 0;
                            items = cart.items.map(function (i) {
                                return analyticsPusherLibrary.cratePushItem(i, i.amount);
                            });
                            _context12.next = 4;
                            return analyticsPusherLibrary.getTotalQuantity(items);

                        case 4:
                            total_quantity = _context12.sent;
                            _context12.t0 = _extends3.default;
                            _context12.t1 = Resx.App.TransportationAndPaymentTitle;
                            _context12.t2 = step;
                            _context12.next = 10;
                            return analyticsPusherLibrary.getCheckoutNameByStep(step);

                        case 10:
                            _context12.t3 = _context12.sent;
                            _context12.t4 = total_quantity;
                            _context12.t5 = {
                                event: 'checkout',
                                TransportationAndPaymentTitle: _context12.t1,
                                checkout_step: _context12.t2,
                                checkout_name: _context12.t3,
                                total_quantity: _context12.t4
                            };
                            _context12.next = 15;
                            return analyticsPusherLibrary.getPriceValuesObject(cart);

                        case 15:
                            _context12.t6 = _context12.sent;
                            _context12.t7 = {
                                ecommerce: {
                                    items: items
                                }
                            };
                            dataObject = (0, _context12.t0)(_context12.t5, _context12.t6, _context12.t7);
                            _context12.next = 20;
                            return analyticsPusherLibrary.addCouponValues(dataObject, cart);

                        case 20:
                            _context12.next = 22;
                            return analyticsPusherLibrary.fillPaymentOrDelivery(cart, dataObject, false);

                        case 22:
                            _context12.next = 24;
                            return analyticsPusherLibrary.fillPaymentOrDelivery(cart, dataObject, true);

                        case 24:
                            _context12.next = 26;
                            return analyticsPusherLibrary.performPush(dataObject, true);

                        case 26:
                            _context12.next = 32;
                            break;

                        case 28:
                            _context12.prev = 28;
                            _context12.t8 = _context12["catch"](0);
                            _context12.next = 32;
                            return console.error("Error in performing push checkout (moving between cart steps).", _context12.t8);

                        case 32:
                        case "end":
                            return _context12.stop();
                    }
                }
            }, _callee12, undefined, [[0, 28]]);
        }));

        return function pushCheckout(_x13, _x14) {
            return _ref12.apply(this, arguments);
        };
    }(),

    pushPurchase: function () {
        var _ref13 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee13() {
            var orderCompletedValuesElement, orderData, previousStateData, items, total_quantity, dataObject, contact;
            return _regenerator2.default.wrap(function _callee13$(_context13) {
                while (1) {
                    switch (_context13.prev = _context13.next) {
                        case 0:
                            _context13.prev = 0;
                            orderCompletedValuesElement = document.getElementById('orderCompletedValues');

                            if (orderCompletedValuesElement) {
                                _context13.next = 4;
                                break;
                            }

                            return _context13.abrupt("return");

                        case 4:
                            // order data serialized on page
                            orderData = JSON.parse(orderCompletedValuesElement.value);
                            // cart data snapshot just before order was sent, longer lifetime is for cases, 
                            // when customer spends long time on payment gate 

                            previousStateData = _storageProvider2.default.getValue(_storageProvider2.default.previousCartPersistedKey, 30) || {};
                            // already pushed case or processing took probably too long, so bad luck...

                            if (!(!orderData || !previousStateData || !previousStateData.cart)) {
                                _context13.next = 8;
                                break;
                            }

                            return _context13.abrupt("return");

                        case 8:
                            items = previousStateData.cart.items.map(function (i) {
                                return analyticsPusherLibrary.cratePushItem(i, i.amount);
                            });
                            _context13.next = 11;
                            return analyticsPusherLibrary.getTotalQuantity(items);

                        case 11:
                            total_quantity = _context13.sent;
                            _context13.t0 = _extends3.default;
                            _context13.t1 = {
                                event: 'purchase',
                                purchase_id: orderData.Reference,
                                email: orderData.CustomerEmail,
                                checkout_step: 4,
                                checkout_name: Resx.App.OrderConfirmation,
                                currency: _utils2.default.getCurrencyIntCode(),
                                total_quantity: total_quantity
                            };
                            _context13.next = 16;
                            return analyticsPusherLibrary.getPriceValuesObject(previousStateData.cart);

                        case 16:
                            _context13.t2 = _context13.sent;
                            _context13.t3 = {
                                ecommerce: {
                                    items: items
                                }
                            };
                            dataObject = (0, _context13.t0)(_context13.t1, _context13.t2, _context13.t3);


                            if (previousStateData.customer && previousStateData.customer.contact) {
                                contact = previousStateData.customer.contact;

                                dataObject.phone = contact.phoneNumberWithCode;
                                dataObject.shipping_first_name = contact.firstName;
                                dataObject.shipping_last_name = contact.lastName;
                                dataObject.shipping_street = contact.street;
                                dataObject.shipping_city = contact.city;
                                dataObject.shipping_zip = contact.postCode;
                            }

                            _context13.next = 22;
                            return analyticsPusherLibrary.fillPaymentOrDelivery(previousStateData.cart, dataObject, false);

                        case 22:
                            _context13.next = 24;
                            return analyticsPusherLibrary.fillPaymentOrDelivery(previousStateData.cart, dataObject, true);

                        case 24:
                            _context13.next = 26;
                            return analyticsPusherLibrary.addCouponValues(dataObject, previousStateData.cart);

                        case 26:
                            _context13.next = 28;
                            return analyticsPusherLibrary.performPush(dataObject, true);

                        case 28:
                            _storageProvider2.default.clearValue(_storageProvider2.default.previousCartPersistedKey);
                            _context13.next = 35;
                            break;

                        case 31:
                            _context13.prev = 31;
                            _context13.t4 = _context13["catch"](0);
                            _context13.next = 35;
                            return console.error("Error in performing push of sent order (pushPurchase).", _context13.t4);

                        case 35:
                        case "end":
                            return _context13.stop();
                    }
                }
            }, _callee13, undefined, [[0, 31]]);
        }));

        return function pushPurchase() {
            return _ref13.apply(this, arguments);
        };
    }(),

    pushSearch: function () {
        var _ref14 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee14() {
            var element, path, url, dataObject;
            return _regenerator2.default.wrap(function _callee14$(_context14) {
                while (1) {
                    switch (_context14.prev = _context14.next) {
                        case 0:
                            _context14.prev = 0;
                            element = document.getElementById('searchPagePhraseElement');

                            if (element) {
                                _context14.next = 4;
                                break;
                            }

                            return _context14.abrupt("return");

                        case 4:
                            path = document.location.href;

                            if (document.referrer && document.referrer.length > 5) {
                                url = new URL(document.referrer);

                                path = url.pathname;
                            }

                            dataObject = {
                                event: 'search',
                                ecommerce: {
                                    page_path: path,
                                    search_term: element.value
                                }
                            };

                            console.debug(dataObject.event, dataObject);
                            // await analyticsPusherLibrary.performPush(dataObject, true);

                            _context14.next = 14;
                            break;

                        case 10:
                            _context14.prev = 10;
                            _context14.t0 = _context14["catch"](0);
                            _context14.next = 14;
                            return console.error("Error in performing push of search event.", _context14.t0);

                        case 14:
                        case "end":
                            return _context14.stop();
                    }
                }
            }, _callee14, undefined, [[0, 10]]);
        }));

        return function pushSearch() {
            return _ref14.apply(this, arguments);
        };
    }(),

    performPush: function () {
        var _ref15 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee15(dataObject) {
            var ecommerceNull = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
            var settings, pushMode;
            return _regenerator2.default.wrap(function _callee15$(_context15) {
                while (1) {
                    switch (_context15.prev = _context15.next) {
                        case 0:
                            _context15.prev = 0;
                            _context15.next = 3;
                            return analyticsPusherLibrary.getCustomerDetails();

                        case 3:
                            settings = _context15.sent;

                            if (settings) {
                                _context15.next = 7;
                                break;
                            }

                            console.error("No settings present. Presence of element customerInfoElement is expected here.");
                            return _context15.abrupt("return");

                        case 7:
                            pushMode = _common2.default.convertIntSafe(settings.pushMode);
                            // push

                            if ((pushMode & 1) === 1) {
                                if (ecommerceNull) window.dataLayer.push({ ecommerce: null });
                                window.dataLayer.push(dataObject);
                            }
                            // log

                            if (!((pushMode & 2) === 2)) {
                                _context15.next = 12;
                                break;
                            }

                            _context15.next = 12;
                            return console.debug("Pushing object to GA. Event: " + dataObject.event, dataObject);

                        case 12:
                            _context15.next = 18;
                            break;

                        case 14:
                            _context15.prev = 14;
                            _context15.t0 = _context15["catch"](0);
                            _context15.next = 18;
                            return console.error("Error in performing Datalayer push.", _context15.t0);

                        case 18:
                        case "end":
                            return _context15.stop();
                    }
                }
            }, _callee15, undefined, [[0, 14]]);
        }));

        return function performPush(_x15) {
            return _ref15.apply(this, arguments);
        };
    }()
};


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/analyticsPusherLibrary.js
// module id = 229
// module chunks = 0 1 2